import type { FormatterType } from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/getFormatterType";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";

export const questionFormatter =
	(formatter: FormatterType): NodeSerializerSpec =>
	async (state, node) => {
		const attrs: Record<string, unknown> = { id: node.attrs.id, type: node.attrs.type };
		if (node.attrs.required) attrs.required = "true";

		await state.wrapContainer(
			formatter.openTag("question", attrs),
			formatter.closeTag("question"),
			node,
			async () => {
				for (let i = 0; i < node.childCount; i++) {
					const child = node.child(i);
					// Answers are the structural children of a question, as tabs are of `tabs`: no blank line between them.
					if (i && child.type.name === "questionAnswer" && node.child(i - 1).type.name === "questionAnswer")
						state.flushClose(1);
					await state.render(child, node, i);
				}
			},
			formatter.indentsContainers,
		);
	};
